/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Approve_ErrorInputs */

const vi_stocktake_approve_error = /** @type {(inputs: Stocktake_Approve_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không duyệt được phiếu`)
};

/**

* @param {Stocktake_Approve_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_approve_error = /** @type {((inputs?: Stocktake_Approve_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Approve_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_approve_error(inputs)
});